import type { AppCode, Message } from "./schema";

/**
 * Browser-state key names — spec §Consumer local state. The consumer owns every read and
 * write (wrapped in try/catch; a failure means "not dismissed, not seen"); this module only
 * names the keys and the store each dismissal goes to.
 */
export function localStateKeys(appCode: AppCode) {
  return {
    /** `{ [messageId]: dismissedAt }` — in the persistent store for `permanent`, the tab store for `session`. */
    dismissed: `iam:${appCode}:dismissed`,
    /** `{ [messageId]: firstSeenAt }` — persistent store; feeds `oncePerBrowser` and the feed unread count. */
    seen: `iam:${appCode}:seen`,
  } as const;
}

/** Which browser store a dismissal goes to: `persistent` (survives the tab), `tab` (this tab only), or none. */
export function dismissStore(dismiss: Message["dismiss"]): "persistent" | "tab" | null {
  if (dismiss === "permanent") return "persistent";
  if (dismiss === "session") return "tab";
  return null;
}
